// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "nav section div:last-of-type i:hover {\n  color: rgb(var(--light-primary-variant)) !important;\n}\n", "",{"version":3,"sources":["webpack://./src/layout/Navbar/navbar.css"],"names":[],"mappings":"AAAA;EACE,mDAAmD;AACrD","sourcesContent":["nav section div:last-of-type i:hover {\n  color: rgb(var(--light-primary-variant)) !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
